import { action, observable } from 'mobx';

export class PointTranslationByCoordinatesVM {
  @observable props;
  constructor(props: any) {
    this.props = props;
  }

  @observable shouldDisplayOnMap = false;

  @action.bound onChangeHandler() {
    this.props.setFormError('');
  }
}
